module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "personalized_learning.55649957.png";